import React from 'react';
import c from 'classnames';

import { DynamicMediaItem } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import type { TaxonomyTheme } from '../../../../../types/uncinc_profile/taxonomy';
import TaxonomyThemeCardChild from '../../Card/Child';

interface ThemeProps {
  entity: ImmutableEntity<TaxonomyTheme>;
}

const TaxonomyThemeTeaserChild: React.FC<ThemeProps> = ({ entity }) => {
  const theme = entity.toJS();
  const langcode = theme.langcode[0].value;
  const url = theme.paths[langcode];
  const title = theme.name[0].value;
  const image = theme.field_media_item[0];
  const classes = c('TaxonomyThemeTeaser', 'TaxonomyThemeTeaser--Child');

  return (
    <TaxonomyThemeCardChild
      className={classes}
      url={url}
      title={title}
      image={(
        <DynamicMediaItem
          media={image}
          imageAspectRatio="1_1"
        />
      )}
    />
  );
};

export default TaxonomyThemeTeaserChild;
